import { render, staticRenderFns } from "./ByTagNumber.vue?vue&type=template&id=fa06bd7e&scoped=true&"
import script from "./ByTagNumber.vue?vue&type=script&lang=js&"
export * from "./ByTagNumber.vue?vue&type=script&lang=js&"
import style0 from "./ByTagNumber.vue?vue&type=style&index=0&id=fa06bd7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa06bd7e",
  null
  
)

export default component.exports